import { ReactCompareSlider, ReactCompareSliderImage } from "react-compare-slider";
import { resolveImageUrl } from "./ContentBlocks";

/**
 * Shared renderer for `before_after` blocks.
 * Layouts: side_by_side | stacked | slider
 */
export function BeforeAfterDisplay({ block, className = "" }) {
  const beforeSrc = resolveImageUrl(block.before_url);
  const afterSrc = resolveImageUrl(block.after_url);
  if (!beforeSrc && !afterSrc) return null;

  const layout = block.layout || "side_by_side";
  const w = block.width || "full";
  const widthStyle = w === "full" ? "100%" : `${w}%`;
  const beforeLabel = block.before_label || "Before";
  const afterLabel = block.after_label || "After";

  const Slot = ({ src, label }) => (
    <div className="relative rounded-lg overflow-hidden bg-slate-100 border border-slate-200">
      {src ? (
        <img src={src} alt={label} className="w-full h-auto object-contain" />
      ) : (
        <div className="aspect-[4/3] flex items-center justify-center text-slate-400 text-xs italic">No {label.toLowerCase()} photo</div>
      )}
      <div className="absolute top-2 left-2 bg-black/70 text-white text-[11px] font-bold uppercase tracking-wide px-2 py-0.5 rounded">{label}</div>
    </div>
  );

  const Caption = () => (block.caption ? <p className="text-center text-xs text-slate-500 mt-2 italic">{block.caption}</p> : null);

  if (layout === "slider" && beforeSrc && afterSrc) {
    return (
      <div className={className} style={{ width: widthStyle, margin: "0 auto" }}>
        <div className="rounded-lg overflow-hidden border border-slate-200 bg-slate-100">
          <ReactCompareSlider
            itemOne={<ReactCompareSliderImage src={beforeSrc} alt={beforeLabel} style={{ objectFit: "contain" }} />}
            itemTwo={<ReactCompareSliderImage src={afterSrc} alt={afterLabel} style={{ objectFit: "contain" }} />}
            style={{ width: "100%", height: "auto", minHeight: 260 }}
          />
        </div>
        <div className="flex justify-between text-[10px] font-bold uppercase tracking-wide text-slate-500 mt-1 px-1">
          <span>{beforeLabel}</span>
          <span className="italic text-slate-400">← drag →</span>
          <span>{afterLabel}</span>
        </div>
        <Caption />
      </div>
    );
  }

  const isStacked = layout === "stacked";
  return (
    <div className={className} style={{ width: widthStyle, margin: "0 auto" }}>
      <div className={isStacked ? "grid grid-cols-1 gap-2" : "grid grid-cols-2 gap-2"}>
        <Slot src={beforeSrc} label={beforeLabel} />
        <Slot src={afterSrc} label={afterLabel} />
      </div>
      <Caption />
    </div>
  );
}
